import { useContext } from "react";

import { BadgesContext } from "../context/BadgesContext";

export const useBadges = () => {
    const badges = useContext(BadgesContext) || [];

    return badges;
};